import { useState } from "react";
import "./MainBox.css";
import Series from "./US/Series";
import PRHLoader from '../lib/PRHLoader';

export default function accordUS(props) {
    const [activeIndex, setActiveIndex] = useState([]);
    const handleAccordionClick = (index) => {
        const indexExists = activeIndex.includes(index);
        if (indexExists) {
            setActiveIndex(activeIndex.filter((i) => i != index));
        } else {
            setActiveIndex([...activeIndex, index]);
        }
    };

    return (
        <div className="accordion">
            <div className={`accordion-item ${activeIndex.includes(0) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(0)}>
                    Notes
                </div>
                <div className="accordion-content accordian-border">
                    {props?.ISBNId != null && props?.ISBNId != "" ? <PRHLoader></PRHLoader> : "No Title Selected"}
                   
                </div>
            </div>
            <div className={`accordion-item ${activeIndex.includes(1) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(1)}>
                    Forecast & Shipments
                </div>
                <div className="accordion-content accordian-border">
                    {props?.ISBNId != null && props?.ISBNId != "" ? <PRHLoader></PRHLoader> : "No Title Selected"}

                </div>
            </div>

            <div className={`accordion-item ${activeIndex.includes(2) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(2)}>
                    Stock Overview
                </div>
                <div className="accordion-content accordian-border">
                    {props?.ISBNId != null && props?.ISBNId != "" ? <PRHLoader></PRHLoader> : "No Title Selected"}

                </div>
            </div>

           <div className={`accordion-item ${activeIndex.includes(3) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(3)}>
                    POS Demand
                </div>
                <div className="accordion-content accordian-border">
                    {props?.ISBNId != null && props?.ISBNId != "" ? <PRHLoader></PRHLoader> : "No Title Selected"}

                </div>
            </div>

            <div className={`accordion-item ${activeIndex.includes(4) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(4)}>
                    Reprint Inputs
                </div>
                <div className="accordion-content accordian-border">
                    {props?.ISBNId != null && props?.ISBNId != "" ? <PRHLoader></PRHLoader> : "No Title Selected"}

                </div>
            </div>
            < div className={`accordion-item ${activeIndex.includes(5) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(5)}>
                    Components on Hand
                </div>
                <div className="accordion-content accordian-border">
                    {props?.ISBNId != null && props?.ISBNId != "" ? <PRHLoader></PRHLoader> : "No Title Selected"}

                </div>
            </div>
          <div className={`accordion-item ${activeIndex.includes(6) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(6)}>
                 Production Specs
                </div>
                <div className="accordion-content accordian-border">
                    {props?.ISBNId != null && props?.ISBNId != "" ? <PRHLoader></PRHLoader> : "No Title Selected"}

                </div>
            </div>
            < div className={`accordion-item ${activeIndex.includes(9) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(9)}>
                    Series & Author Works
                </div>
                <div className="accordion-content accordian-border">
                    {/*                <Series ISBNId= "9780375813658" metaData={props.metaData} />*/}
                    {props?.ISBNId != null && props?.ISBNId != "" ? <PRHLoader></PRHLoader> : "No Title Selected"}
                </div>
            </div>
            <div className={`accordion-item ${activeIndex.includes(7) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(7)}>
                    Title Family & Packs
                </div>
                <div className="accordion-content accordian-border">
                    {props?.ISBNId != null && props?.ISBNId != "" ? <PRHLoader></PRHLoader> : "No Title Selected"}

                </div>
            </div>
            <div className={`accordion-item ${activeIndex.includes(8) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(8)}>
                    Marketing & Publicity
                </div>
                <div className="accordion-content accordian-border">
                    <div className="accordion-content accordian-border">
                       
                        {props?.ISBNId != null && props?.ISBNId != "" ? <PRHLoader></PRHLoader> : "No Title Selected"}
                                      </div>
                </div>
            </div>
        </div>
    );
}